module.exports = __webpack_public_path__ + "img/the-founders.4a77718e.png";